(function () {
    'use strict';

    angular
        .module('FormBuilder')
        .directive(
            'fbFieldInterviewMediumSelector', fbFieldInterviewMediumSelector);

    function fbFieldInterviewMediumSelector($timeout, lodash) {
        return {
            restrict: "EA",
            scope: {
                element: '=',
                model: "=",
                eventHandler: '&'
            },
            templateUrl: 'common/libraries/formBuilder/fields/fieldInterviewMediumSelector',
            controller: fbFieldInterviewMediumSelectorCtrl,
            controllerAs: 'vm',
            bindToController: true,
            link: function (scope, elem, ctrl) {
                var vm = scope.vm;
                $timeout(function () {
                    var trigger_change = lodash.get(vm.element, 'options.trigger_change_on_load', false);
                    if (trigger_change) {
                        vm.onEventTrigger('onChange');
                    }
                    scope.toggleActive = vm.toggleActive;
                    // elem.find('.selectize-input input').attr('readonly','readonly');;
                });
            }
        };
    }

    function fbFieldInterviewMediumSelectorCtrl(lodash, FormBuilderService, $scope, GenericModel, ActionCommon, $timeout, FbSelectService,RequestHelper) {
        // $scope.$watch(function() { return vm.model; }, function() { console.log('fieldSelect model', vm.model); });
        var vm = this;
        var formIdentifier = '';
        var cdnEp = '';
        this.$onInit = function() {
            if (vm.model === undefined && lodash.has(vm.element, 'options.default')) {
                lodash.set(vm, 'model', vm.element.options.default);
            }
            vm.selectize = null;

            formIdentifier = $scope.$parent.vm.formIdentifier;
            FormBuilderService.sync(formIdentifier, vm);

            //vm.getEventDetails = getEventDetails;
            vm.onEventTrigger = vm.pageData.eventsService.onEventTrigger.bind(vm);
            vm.getModelOptions = vm.pageData.eventsService.getModelOptions.bind(vm);
            vm.element.refreshData = loadRemoteData;

            // preparing additionalOptionss
            vm.eventsCreateOptions = vm.pageData.eventsService.getEventOptions(vm.element.elementIdentifier, 'onCreate');
            vm.additionalOptions = {};

            FbSelectService.initTemplateCall(vm.element.options, vm.additionalOptions);

            if (!lodash.isEmpty(vm.eventsCreateOptions)) {
                // only allow create if eventsCreateOptions is not empty
                vm.additionalOptions.create = createFunc;
            }
            
            if (lodash.has(vm.element, 'options.datasource.data')) {
                vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                $scope.$watch(function () {
                    return vm.element.options.datasource.data;
                }, function () {
                    if (vm.firstLoad) {
                        $timeout(function () {
                            vm.firstLoad = false;
                        });
                    } else {
                        $timeout(function () {
                            vm.isLoading = true;
                            vm.ds = angular.copy(lodash.get(vm.element, 'options.datasource.data', null));
                            $timeout(function () {
                                vm.isLoading = false;
                            }, 800);
                        });
                    }

                });
            }

            if (lodash.has(vm.element, 'options.datasource.optgroup_data')) {
                vm.additionalOptions.optgroups = vm.element.options.datasource.optgroup_data;
            }
            
            
            vm.hasFieldError = hasFieldError;
            vm.fieldErrorMessage = fieldErrorMessage;
            vm.toggleActive = toggleActive;
            vm.showTextbox = showTextbox;
            vm.firstLoad = true;
            vm.toggleState = true;
            vm.selectizeMsg = '';
            cdnEp = angular.element('div[data-cdn-ep]').attr('data-cdn-ep');
            vm.venue_tinymceOptions = {
                plugins: 'link image autoresize paste lists table advlist visualblocks visualchars charmap',
                menubar: false,
                toolbar: 'undo redo',
                preview_styles: false,
                resize: true,
                statusbar: false,
                autoresize_bottom_margin: 0,
                autoresize_min_height: 50,
                debounce: false,
                content_css: cdnEp + '/assets/css/rms-tinymce.css',
                // paste_as_text: true,
                paste_data_images: false,
                setup: function (ed) {
                    ed.on('init', function (inst) {
                        $timeout(function () {
                            var container = angular.element(inst.target.editorContainer);
                            var em = container.find('.mce-toolbar-grp');
                            container.remove('.mce-toolbar-grp');
                            container.find('.mce-edit-area').after(em);
                        });
                    });
                },
                // paste_word_valid_elements: "b,strong,i,em,h1,h2,table,tr,td,ul,ol,li"
            };

            vm.config =
                angular.merge(
                    {
                        highlight: true,
                        create: false,
                        labelField: 'label',
                        valueField: 'value',
                        maxItems: 1,
                        searchField: ['label'],
                        plugins: ['remove_button'],
                        // dropdownParent: 'body',
                        // dropdownClass: 'selectize-dropdown modal-z-index',
                        // placeholder: '',
                        onChange: function(selectedValue) {
                            lodash.set(vm.element, 'attr.show_venue_box',false);
                            lodash.set(vm.element, 'attr.show_input_text',false);
                            vm.element.venue_address = null;

                            const selected = lodash.find(vm.ds, function(item) {
                                return lodash.get(item, lodash.get(vm.config, 'valueField', 'value'), null).toString() === selectedValue.toString();
                            });

                            var itemSetting = lodash.get(selected,'attr',{});
                            lodash.merge(vm.element.attr,itemSetting);
                            var itemAddress = lodash.get(selected,'venue_address',null);
                            vm.element.venue_address = itemAddress;

                            var show_checkbox = lodash.get(vm.element.attr, 'show_checkbox',false);
                            
                            lodash.merge(vm.pageData.model, {
                                'chk_generate_link_automatically':show_checkbox,
                                'txt_web_call_url':null,
                                'txt_venue':itemAddress
                            });

                            vm.onEventTrigger('onChange');
                        },
                        onBlur: function () {
                            vm.onEventTrigger('onBlur');
                        },
                        onInitialize: function (selectize) {
                            vm.selectize = selectize;
                            loadRemoteData();
                            $timeout(function () {
                                emptyOptionLabel();
                                if (vm.element.attr.disable || vm.pageData.fbData.settings.view_only) {
                                    vm.selectize.disable();
                                }
                            });
                        }
                    },
                    lodash.get(vm.element, 'options.selectize', {}),
                    vm.additionalOptions
                );
        };

        function createFunc(value, callback) {

            var formModel = FormBuilderService.getModel(formIdentifier);
            var modelData = {
                data: {label: value, model: formModel}
            };

            var model = new GenericModel(vm.eventsCreateOptions.datasource.url);
            var method = lodash.get(vm.eventsCreateOptions.datasource, 'method', 'post');
            model[method]({}, modelData, function (res) {
                // alert('succes');
                ActionCommon.show_floating_notifier(vm.eventsCreateOptions.successNotifier);
                vm.pageData.eventsService.refreshDataOfElement(vm.element.name);
                // callback, provided by selectize, will add the new option into the select.
                callback(res.item);
            }, handleRequestError);
        }

        function handleRequestError() {
            // alert('failed');
            ActionCommon.show_floating_notifier(vm.eventsCreateOptions.errorNotifier);
        }

        function loadRemoteData() {
            if (lodash.has(vm.element, 'options.datasource.url')) {
                vm.isLoading = true;
                var callRemoteApiPromise = callRemoteApi();
                callRemoteApiPromise.then(function (res) {
                    vm.isLoading = false;
                    var msg = lodash.get(res, 'error_msg');

                    if (msg || res.length === 0) {
                        vm.selectizeMsg = msg;
                        if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                        //     // res.push({"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')});                            
                            var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                            vm.selectize.settings.placeholder = placeholder;
                            vm.selectize.updatePlaceholder();
                        }
                        return vm.selectize.disable();
                    }
                    vm.ds = res;
                });
            }
        }

        function callRemoteApi() {
            var model = new GenericModel(vm.element.options.datasource.url);
            var method = lodash.get(vm.element.options.datasource, 'method', 'get');
            var model_keys = lodash.get(vm.element.options.datasource, 'model_keys',null);
            var model_data = FormBuilderService.getModel(formIdentifier);

            if (model_keys != undefined ){
                model_data = RequestHelper.getNeeded(model_data, model_keys);
            }
            return model[method]({}, {data: model_data}).$promise.then(function (res) { //res
                if (res.success && res.status_code == 200) {
                    return res.data;
                } else {
                    console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                    return null;
                }
            }, function (res) {
                console.warn('Calling ' + vm.element.options.datasource.url + ' fails. Status code: ' + res.status_code); // eslint-disable-line no-console
                console.warn(res); // eslint-disable-line no-console
                return null;
            });
        }

        function emptyOptionLabel() {
            if (lodash.has(vm.element,'options.selectize.emptyOptionLabel')) {
                if (!lodash.has(vm.element, 'options.datasource.url')) {
                    if (vm.ds.length == 0) {
                        // var obj = {"value":0, "label":lodash.get(vm.element,'options.selectize.emptyOptionLabel')};
                        // vm.ds.push(obj);
                        var placeholder = lodash.get(vm.element,'options.selectize.emptyOptionLabel');
                        vm.selectize.settings.placeholder = placeholder;
                        vm.selectize.updatePlaceholder();
                        vm.selectize.disable();
                    }
                }
            }
        }

        function toggleActive() {
            vm.toggleState = !vm.toggleState;
            lodash.merge(vm.pageData.model, {
                'chk_generate_link_automatically':vm.toggleState,
                'txt_web_call_url':null,
                'txt_venue':null
            });
        }

        function hasFieldError(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.has(error_rules, 0, false);
        }

        function fieldErrorMessage(fieldname) {
            var error_rules = vm.pageData.elementsService.getValidationRule(fieldname);
            return lodash.get(error_rules, 0, '');
        }

        function showTextbox() {
            // 1. Check checkbox first.
            var showCheckbox = lodash.get(vm.element, 'attr.show_checkbox',false);

            if(showCheckbox === true && vm.toggleState === true){
                // If checkbox shows and the state is on,
                // Don't show checkbox. Return false straight away.
                return false;
            }

            // 2. Otherwise return show_input_text || show_venue_box,
            //    since I want to show text box container if any is true.
            return lodash.get(vm.element, 'attr.show_input_text', false)
                || lodash.get(vm.element, 'attr.show_venue_box', false);
        }

    }
})();